/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Snapshot_TitleInputs */

const en_options_backup_snapshot_title = /** @type {(inputs: Options_Backup_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Snapshot Settings`)
};

const fr_options_backup_snapshot_title = /** @type {(inputs: Options_Backup_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres des instantanés automatiques`)
};

const de_options_backup_snapshot_title = /** @type {(inputs: Options_Backup_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen für automatische Schnappschüsse`)
};

const it_options_backup_snapshot_title = /** @type {(inputs: Options_Backup_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni automatiche degli snapshot`)
};

const ru_options_backup_snapshot_title = /** @type {(inputs: Options_Backup_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки автоматического создания снимков`)
};

const es_options_backup_snapshot_title = /** @type {(inputs: Options_Backup_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración automática de instantáneas`)
};

const zh_cn2_options_backup_snapshot_title = /** @type {(inputs: Options_Backup_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动快照设置`)
};

const ja_options_backup_snapshot_title = /** @type {(inputs: Options_Backup_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動スナップショット設定`)
};

const hi_options_backup_snapshot_title = /** @type {(inputs: Options_Backup_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित स्नैपशॉट सेटिंग्स`)
};

const pt_pt2_options_backup_snapshot_title = /** @type {(inputs: Options_Backup_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações automáticas de captura de instantâneos`)
};

/**
* | output |
* | --- |
* | "Automatic Snapshot Settings" |
*
* @param {Options_Backup_Snapshot_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_snapshot_title = /** @type {((inputs?: Options_Backup_Snapshot_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Snapshot_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_snapshot_title(inputs)
	if (locale === "de") return de_options_backup_snapshot_title(inputs)
	if (locale === "it") return it_options_backup_snapshot_title(inputs)
	if (locale === "ru") return ru_options_backup_snapshot_title(inputs)
	if (locale === "es") return es_options_backup_snapshot_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_snapshot_title(inputs)
	if (locale === "ja") return ja_options_backup_snapshot_title(inputs)
	if (locale === "hi") return hi_options_backup_snapshot_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_snapshot_title(inputs)
	return en_options_backup_snapshot_title(inputs)
});